import { useSearchParams } from "react-router";
import { useCallback } from "react";

function useUpdateQueryParams() {
    const [searchParams, setSearchParams] = useSearchParams();

    const updateQueryParams = useCallback(
        (newParams: Record<string, string | undefined>) => {
            const updatedSearchParams = new URLSearchParams(searchParams);

            Object.entries(newParams).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    updatedSearchParams.set(key, value);
                } else {
                    updatedSearchParams.delete(key);
                }
            });

            setSearchParams(updatedSearchParams, { replace: true });
        },
        [searchParams, setSearchParams]
    );

    return updateQueryParams;
}

export default useUpdateQueryParams;
